export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/04ad07ad3dfb19554d0c75ac656e1703.jpg')`
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            農薬散布・請負サービス
          </h1>
          <p className="text-xl md:text-2xl mb-4 font-medium">
            散布作業、すべてお任せください
          </p>
          <p className="text-lg md:text-xl mb-8 leading-relaxed">
            IDS教習所グループでは、佐賀県・福岡県筑後地区・鹿児島県を中心に、<br className="hidden md:block" />
            農業ドローンによる散布代行サービスを提供しています。<br className="hidden md:block" />
            経験豊富な操縦士が、安全・確実・スピーディーに作業を完遂いたします。
          </p>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 mb-8">
            <h3 className="text-xl md:text-2xl font-bold mb-4 text-[#76B947]">こんな方におすすめ</h3>
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#76B947] text-xl mt-1 flex-shrink-0"></i>
                <span>ドローンを買う前に、まずは効果を試してみたい</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#76B947] text-xl mt-1 flex-shrink-0"></i>
                <span>繁忙期だけ散布をお願いしたい</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#76B947] text-xl mt-1 flex-shrink-0"></i>
                <span>高齢で重労働がつらくなってきた</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-check-line text-[#76B947] text-xl mt-1 flex-shrink-0"></i>
                <span>広い圃場を短時間で散布したい</span>
              </div>
              <div className="flex items-start space-x-3 md:col-span-2">
                <i className="ri-check-line text-[#76B947] text-xl mt-1 flex-shrink-0"></i>
                <span>中山間地域の複雑な圃場でも対応してほしい</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              className="px-8 py-4 bg-[#4CAF50] text-white rounded-lg hover:bg-[#45a049] transition-colors font-semibold text-lg whitespace-nowrap cursor-pointer"
              onClick={() => {
                const contactSection = document.querySelector('[data-contact-section]');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              お見積り・ご相談
            </button>
            <button 
              className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border border-white rounded-lg hover:bg-white/30 transition-colors font-semibold text-lg whitespace-nowrap cursor-pointer"
              onClick={() => {
                const locationsSection = document.querySelector('[data-locations-section]');
                if (locationsSection) {
                  locationsSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              対応エリアを確認
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}